import { h, VNode, FunctionComponent, toChildArray } from "preact"; /** @jsx h */

import { clsx } from 'clsx';

import { useState, useEffect, useRef } from 'preact/hooks';

import { Item, type IItemProps } from './Item';
import { ROUTES } from "@pyqml/shared";

export type INavbarProps = {
	// see: https://stackoverflow.com/questions/66597639/preact-typescript-only-allow-a-specific-component-as-children
    children?: VNode<IItemProps>;

    title: string;
	logo?: string;
};

export const Navbar = (props: INavbarProps) => {
    
	const [show, setShow] = useState(false);

	const navRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		const handleClickOutside = (event: MouseEvent) => {
			if (navRef.current && !navRef.current.contains(event.target as Node)) {
				setShow(false);
			}
		};

		document.addEventListener('mousedown', handleClickOutside);
		return () => {
			document.removeEventListener('mousedown', handleClickOutside);
		};
	}, [navRef]);

    return (
        <nav className="topnav navbar navbar-expand-lg navbar-light bg-white fixed-top">
            <div className="container">
	            <a className="navbar-brand" href={ROUTES.BLOG_HOME}>
					{
						props.logo && <img src={props.logo} alt="logo" className="navbar-logo"/>
					}
					<strong>{props.title}</strong>
				</a>
				<button
					className="navbar-toggler collapsed"
					type="button" data-toggle="collapse"
					data-target="#navbarColor02" aria-controls="navbarColor02" aria-expanded="false" aria-label="Toggle navigation"
					onClick={() => setShow(!show)}
				>
					<span className="navbar-toggler-icon"></span>
				</button>
				<div ref={navRef} className={clsx("navbar-collapse collapse", show ? "show" : "")} id="navbarColor02" style="">
					<ul className="navbar-nav mr-auto d-flex align-items-center">
					{
						toChildArray(
							props.children
						).filter((child: any) => child.props.align !== 'right')
					}
					</ul>
					<ul className="navbar-nav ml-auto d-flex align-items-center">
					{
						toChildArray(
							props.children
						).filter((child: any) => child.props.align === 'right')
					}
					</ul>
				</div>
			</div>
		</nav>
	);
}

/**
 * static properties of the Cards
 */
export type INavigation = {
    Item: FunctionComponent<IItemProps>;
    Navbar: FunctionComponent<INavbarProps>;
}

export const Navigation: INavigation = {
    Navbar,
    Item
};
